var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_vm._l((_vm.risks),function(item){return _c('div',{key:item.title},[_c('div',[_vm._v(_vm._s(item.title))]),_c('br'),_c('div',[_vm._v(_vm._s(item.content))]),_c('br')])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }